import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_workbox_3374283c from 'nuxt_plugin_workbox_3374283c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_0db8167c from 'nuxt_plugin_nuxticons_0db8167c' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_nuxtmq_8bcb1064 from 'nuxt_plugin_nuxtmq_8bcb1064' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_markdownit_7268f410 from 'nuxt_plugin_markdownit_7268f410' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_recaptcha_1f812896 from 'nuxt_plugin_recaptcha_1f812896' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_libmoduleplugin1e0320f0_25f81b71 from 'nuxt_plugin_libmoduleplugin1e0320f0_25f81b71' // Source: ./lib.module.plugin.1e0320f0.js (mode: 'all')
import nuxt_plugin_nuxtplugin79ffe248_0323c6a2 from 'nuxt_plugin_nuxtplugin79ffe248_0323c6a2' // Source: ./nuxt.plugin.79ffe248.js (mode: 'all')
import nuxt_plugin_storage_25489bf2 from 'nuxt_plugin_storage_25489bf2' // Source: ../plugins/storage (mode: 'server')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_googlemaps_c54ce192 from 'nuxt_plugin_googlemaps_c54ce192' // Source: ../plugins/google-maps (mode: 'client')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_contentful_fe22a150 from 'nuxt_plugin_contentful_fe22a150' // Source: ../plugins/contentful (mode: 'all')
import nuxt_plugin_metadata_3ceffd23 from 'nuxt_plugin_metadata_3ceffd23' // Source: ../plugins/metadata (mode: 'all')
import nuxt_plugin_vmask_42ab70d7 from 'nuxt_plugin_vmask_42ab70d7' // Source: ../plugins/v-mask (mode: 'all')
import nuxt_plugin_toquerystring_3c12cb58 from 'nuxt_plugin_toquerystring_3c12cb58' // Source: ../plugins/to-query-string (mode: 'all')
import nuxt_plugin_okta_92649d86 from 'nuxt_plugin_okta_92649d86' // Source: ../plugins/okta (mode: 'client')
import nuxt_plugin_ie_170fd3e0 from 'nuxt_plugin_ie_170fd3e0' // Source: ../plugins/ie (mode: 'client')
import nuxt_plugin_vueanimate_ece679b4 from 'nuxt_plugin_vueanimate_ece679b4' // Source: ../plugins/vue-animate (mode: 'client')
import nuxt_plugin_accessibe_227cf314 from 'nuxt_plugin_accessibe_227cf314' // Source: ../plugins/accessibe (mode: 'client')
import nuxt_plugin_mulesoft_7dec4ebf from 'nuxt_plugin_mulesoft_7dec4ebf' // Source: ../plugins/mulesoft (mode: 'client')
import nuxt_plugin_mulesoftv3_97d8ad08 from 'nuxt_plugin_mulesoftv3_97d8ad08' // Source: ../plugins/mulesoftv3 (mode: 'client')
import nuxt_plugin_vuefriendlyiframe_397f0d6a from 'nuxt_plugin_vuefriendlyiframe_397f0d6a' // Source: ../plugins/vue-friendly-iframe (mode: 'all')
import nuxt_plugin_bugsnag_6b5683c1 from 'nuxt_plugin_bugsnag_6b5683c1' // Source: ../plugins/bugsnag (mode: 'client')
import nuxt_plugin_vuemq_469da63f from 'nuxt_plugin_vuemq_469da63f' // Source: ../plugins/vue-mq (mode: 'client')
import nuxt_plugin_vuebgvideo_37c0a54e from 'nuxt_plugin_vuebgvideo_37c0a54e' // Source: ../plugins/vue-bg-video (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Main Event","title":"Main Event","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"apple-mobile-web-app-title","content":"Main Event"},{"name":"google-site-verification","content":"lc09iDr0xdFI5oPcvBFFl-NK0DSL1VHNwDsDvml-slE"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"hid":"description","name":"description","content":"The perfect place for birthday parties, team building, corporate events & parties, meetings & happy hour! FUN & entertainment with family & friends."},{"hid":"og:site_name","name":"og:site_name","content":"Main Event"},{"hid":"og:title","template":chunk => `${chunk} | ${process.env.npm_package_title}`},{"hid":"og:image","name":"og:image","content":"TBD"},{"hid":"og:image:width","name":"og:image:width","content":"1440"},{"hid":"og:image:height","name":"og:image:height","content":"672"},{"name":"twitter:site","content":"https:\u002F\u002Ftwitter.com\u002FMyMainEvent"},{"name":"twitter:card","content":"summary_large_image"},{"name":"apple-itunes-app","content":"app-id=1498119666"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"author","name":"author","content":"Main Event Entertainment"},{"hid":"theme-color","name":"theme-color","content":"#fff"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Main Event"},{"hid":"og:description","name":"og:description","property":"og:description","content":"The perfect place for birthday parties, team building, corporate events & parties, meetings & happy hour! FUN & entertainment with family & friends."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fuse.typekit.net\u002Fdwh3ylg.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"\u002F\u002Fassets.sitescdn.net\u002Fanswers\u002Fv1\u002Fanswers.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.1b92c867.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64.940800.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.940800.png","sizes":"512x512"}],"script":[{"src":"https:\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=OPT-52X33FC"},{"src":"\u002F\u002Fassets.sitescdn.net\u002Fanswers\u002Fv1\u002Fanswers.min.js"}],"style":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_3374283c === 'function') {
    await nuxt_plugin_workbox_3374283c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_0db8167c === 'function') {
    await nuxt_plugin_nuxticons_0db8167c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_8bcb1064 === 'function') {
    await nuxt_plugin_nuxtmq_8bcb1064(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_7268f410 === 'function') {
    await nuxt_plugin_markdownit_7268f410(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_1f812896 === 'function') {
    await nuxt_plugin_recaptcha_1f812896(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugin1e0320f0_25f81b71 === 'function') {
    await nuxt_plugin_libmoduleplugin1e0320f0_25f81b71(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin79ffe248_0323c6a2 === 'function') {
    await nuxt_plugin_nuxtplugin79ffe248_0323c6a2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storage_25489bf2 === 'function') {
    await nuxt_plugin_storage_25489bf2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_c54ce192 === 'function') {
    await nuxt_plugin_googlemaps_c54ce192(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_contentful_fe22a150 === 'function') {
    await nuxt_plugin_contentful_fe22a150(app.context, inject)
  }

  if (typeof nuxt_plugin_metadata_3ceffd23 === 'function') {
    await nuxt_plugin_metadata_3ceffd23(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_42ab70d7 === 'function') {
    await nuxt_plugin_vmask_42ab70d7(app.context, inject)
  }

  if (typeof nuxt_plugin_toquerystring_3c12cb58 === 'function') {
    await nuxt_plugin_toquerystring_3c12cb58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_okta_92649d86 === 'function') {
    await nuxt_plugin_okta_92649d86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ie_170fd3e0 === 'function') {
    await nuxt_plugin_ie_170fd3e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueanimate_ece679b4 === 'function') {
    await nuxt_plugin_vueanimate_ece679b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_accessibe_227cf314 === 'function') {
    await nuxt_plugin_accessibe_227cf314(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mulesoft_7dec4ebf === 'function') {
    await nuxt_plugin_mulesoft_7dec4ebf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mulesoftv3_97d8ad08 === 'function') {
    await nuxt_plugin_mulesoftv3_97d8ad08(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefriendlyiframe_397f0d6a === 'function') {
    await nuxt_plugin_vuefriendlyiframe_397f0d6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnag_6b5683c1 === 'function') {
    await nuxt_plugin_bugsnag_6b5683c1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemq_469da63f === 'function') {
    await nuxt_plugin_vuemq_469da63f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuebgvideo_37c0a54e === 'function') {
    await nuxt_plugin_vuebgvideo_37c0a54e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
